import SearchStore, { SearchScenarioStore } from './schema/SearchStore';
import { ObservableMap } from 'mobx';
import { PillSuggestion, SubstrateSearchSuggestionSegment } from 'owa-search-service';
import { createStore } from 'satcheljs';

export const createDefaultSearchStore = (): SearchScenarioStore => {
    return {
        alteredQuery: '',
        currentSearchQueryId: null,
        currentSuggestions: null,
        displayedQFRequestTime: null,
        flaggedTokens: [],
        isLastKeyPressedDeletion: false,
        isSuggestionsCalloutClickable: false,
        isSuggestionsDropdownVisible: false,
        isUsing3S: null,
        latestQFRequestId: null,
        latestRenderedQFTraceId: null,
        latestQFTraceId: null,
        latestTraceId: null,
        nextSearchQueryId: null,
        recourseQuery: '',
        searchBoxHasFocus: false,
        searchBoxWidth: null,
        searchSessionGuid: null,
        searchText: '',
        searchTextForSuggestion: '',
        selectedPillIndex: -1,
        selectedSuggestionIndex: -1,
        showRefiners: false,
        suggestedSearchTerm: '',
        suggestedSearchTermReferenceId: '',
        suggestionPillIds: [],
        suggestionPills: new ObservableMap<string, PillSuggestion>(),
        suggestionSegments: new ObservableMap<string, SubstrateSearchSuggestionSegment>(),
        queryAlterationType: null,
        queryActionSource: null,
    };
};

export const searchStore: SearchStore = {
    scenarioStores: new ObservableMap<string, SearchScenarioStore>(),
};

export const getStore = createStore<SearchStore>('commonSearchStore', searchStore);
export default getStore;
